// Polyfills (For IE)
import 'core-js/fn/array/find';
import 'core-js/fn/array/includes';
import 'core-js/fn/number/is-nan';
import 'core-js/fn/object/assign';
import 'core-js/fn/promise';
import 'core-js/fn/string/starts-with';

import Vue from 'vue';
import VueHead from 'vue-head';
import App from './App.vue';
import router from './router';
import store from './store';
import SocialSharing from 'vue-social-sharing';
import PortalVue from 'portal-vue';
import Modal from './components/modal/Modal';
import VueGtag from 'vue-gtag';

import vSelect from 'vue-select';

Vue.component('v-select', vSelect);
Vue.component('modal', Modal);
Vue.use(PortalVue);

Vue.use(VueHead, {
  separator: '|',
});

Vue.use(SocialSharing);

// Google analytics
const gtmId = document.getElementById('app').dataset.gtmId;
const showContentRibbon = parseInt(document.getElementById('app').dataset.showContentRibbon, 10);
const addExtraSpace = parseInt(document.getElementById('app').dataset.addExtraSpace, 10);

if (gtmId) {
  Vue.use(VueGtag, {
    config: {
      id: gtmId,
      params: {
        send_page_view: false,
      },
    },
  }, router);
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App, {
    props: {
      showContentRibbon: showContentRibbon,
      addExtraSpace: addExtraSpace,
    },
  }),
}).$mount('#app');
